<template>
    <div>
        <button type="button" @click="openSlideOver">
            <slot></slot>
        </button>

        <SlideOver :show="open" @close="open = false">
            <div class="mt-3 flex justify-between">
                <h2 class="text-lg leading-6 font-medium text-gray-900 mb-3">
                    {{ programming_subject.subject.name }} - {{ $tc('messages.sessions', 1) }} {{ session.order }}
                </h2>

                <div>
                    <AppButton
                        element="InertiaLink"
                        :href="route('session.activities.create', this.session.id)"
                        v-if="activities.length > 0 && state === 'loaded'"
                    >
                        {{ $t('messages.create_multiple') }}
                    </AppButton>

                    <AppButton
                        desired-action
                        element="button"
                        type="button"
                        @click="submit"
                        v-if="activities.length > 0"
                    >
                        {{ $t('messages.save') }}
                    </AppButton>
                </div>
            </div>

            <div v-if="state === 'loading'" class="animate-pulse">
                <ul>
                    <li v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]" :key="i">
                        <div class="flex space-x-2 align-middle h-6">
                            <input
                                type="checkbox"
                                disabled
                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                            />
                            <div class="inline-block h-4 w-40 bg-gray-300 rounded">&nbsp;</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div v-else-if="state === 'loaded'">
                <div v-if="activities.length === 0">
                    <div class="flex flex-col items-center justify-center max-w-md p-6 mx-auto space-y-6 text-center">
                        <div
                            class="flex items-center justify-center w-16 h-16 text-indigo-500 rounded-full bg-indigo-50"
                        >
                            <svg
                                class="w-8 h-8"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"></path>
                                <path
                                    d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z"
                                ></path>
                            </svg>
                        </div>

                        <header class="max-w-xs space-y-1">
                            <h2 class="text-xl font-semibold tracking-tight">
                                {{ $t('messages.without_activities') }}
                            </h2>

                            <p class="text-sm font-medium text-gray-500">
                                <!--                                You don't have any remaing todos left. Created todos will appear here.-->
                            </p>
                        </header>

                        <AppButton element="InertiaLink" :href="route('session.activities.create', this.session.id)">
                            {{ $t('messages.create_multiple') }}
                        </AppButton>
                    </div>
                </div>
                <ul v-else>
                    <draggable
                        v-model="activities"
                        group="people"
                        @start="drag = true"
                        @end="drag = false"
                        handle=".handle"
                        item-key="id"
                    >
                        <template #item="{ element: activity }">
                            <li>
                                <label>
                                    <input
                                        type="checkbox"
                                        v-model="activity.is_selected"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                    />
                                    <IconGripVertical
                                        v-if="activity.is_selected"
                                        class="handle inline-block h-4 w-4 text-gray-600 cursor-move"
                                    />

                                    <ActivityIcon :type="activity.type" :title="activity.type_display" />

                                    <div
                                        class="inline-block"
                                        :title="$t('messages.to_be_graded')"
                                        v-if="activity.weight"
                                    >
                                        <svg
                                            class="w-4 h-4 text-gray-400"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                clip-rule="evenodd"
                                            ></path>
                                        </svg>
                                    </div>

                                    {{ activity.title }}
                                </label>
                            </li>
                        </template>
                    </draggable>
                    <!--                    <li v-for="activity in activities" :key="activity.id">-->
                    <!--                        <label>-->
                    <!--                            <input type="checkbox" v-model="activity.is_selected" class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">-->
                    <!--                            {{ activity.title }}-->
                    <!--                        </label>-->
                    <!--                    </li>-->
                </ul>
            </div>
        </SlideOver>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import ActivityIcon from '@/components/ActivityIcon.vue';
import axios from 'axios';
import SlideOver from '@/components/SlideOver.vue';
import InertiaLinkButton from '@/components/InertiaLinkButton.vue';
import AppButton from '@/components/AppButton.vue';
import { IconGripVertical } from '@tabler/icons-vue';

export default {
    components: {
        draggable,
        ActivityIcon,
        SlideOver,
        InertiaLinkButton,
        AppButton,
        IconGripVertical,
    },
    emits: ['programmingUpdated'],
    name: 'AddSessionActivitiesForm',
    props: {
        session: {
            required: true,
        },
        programming: {
            required: true,
        },
        programming_subject: {
            required: true,
        },
    },
    data() {
        return {
            open: false,
            state: 'loading',
            activities: [],
            form: this.$inertia.form({
                quantity: 1,
            }),
        };
    },
    computed: {
        selectedActivities: function () {
            return this.activities.filter((a) => a.is_selected).map((a) => a.id);
        },
    },
    methods: {
        openSlideOver() {
            this.open = true;
            const params = {
                school_year_id: this.programming.school_year_id,
                subject_id: this.programming_subject.subject.id,
                // trimester: this.programming.trimester,
                grade_level_ids: this.programming.grade_level_ids,
                session_id: this.session.id,
            };

            axios
                .get(this.route('activity.session.search', params))
                .then((response) => (this.activities = response.data.activities))
                .then(() => {
                    this.state = 'loaded';
                });
        },
        submit() {
            // const activities = this.activities.filter(a => a.is_selected).map(a => a.id);
            const activities = this.selectedActivities;
            this.$inertia.post(
                this.route('session.activities-attach.store', this.session.id),
                {
                    activities,
                },
                {
                    onFinish: () => {
                        this.open = false;
                    },
                    preserveScroll: true,
                    onSuccess: () => this.$emit('programmingUpdated'),
                },
            );
        },
    },
};
</script>
